import * as React from "react";
import { useLayoutEffect } from "./useLayoutEffect.js";
import { useController } from "../modules/Controller.js";
export function useLoseFocus() {
  var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var focused = React.useRef(disabled);

  var _useController = useController(),
      transferFocus = _useController.transferFocus;

  useLayoutEffect(function () {
    if (disabled) {
      transferFocus();
    }
  }, [disabled, transferFocus]);
  var onFocus = React.useCallback(function () {
    focused.current = true;
  }, []);
  var onBlur = React.useCallback(function () {
    focused.current = false;
  }, []);
  return {
    onFocus: onFocus,
    onBlur: onBlur
  };
}